import RatingStars from '@/storybook/components/RatingStarts/RatingStars';
import { SelectItem } from '@/types/ui';
import { ForwardedRef, forwardRef } from 'react';
import styles from './DropdownValueWithRatingStars.module.css';

export type DropdownValueWithRatingStarsProps<T = string> = {
  value: SelectItem<T>[];
};

function DropdownValueWithRatingStars<T>(
  { value }: DropdownValueWithRatingStarsProps<T>,
  ref: ForwardedRef<HTMLDivElement>,
) {
  return (
    <div ref={ref} className={styles.multiLevelValueList}>
      {value.map((opt, i) => (
        <span
          key={`${String(opt.value)}-${i}`}
          className={styles.valueItem}
          data-testid={`valueWithRating-${String(opt.value)}`}
        >
          <span>{opt.label}</span>
          <RatingStars rate={opt.level ?? 0} data-testid={`ratingStars-${String(opt.value)}`} />
          {value.length > 1 && i < value.length - 1 && <span>, </span>}
        </span>
      ))}
    </div>
  );
}

export default forwardRef(DropdownValueWithRatingStars);
